import { render, staticRenderFns } from "./LyricPreview.vue?vue&type=template&id=4ba9c2dc&scoped=true"
import script from "./LyricPreview.vue?vue&type=script&lang=js"
export * from "./LyricPreview.vue?vue&type=script&lang=js"
import style0 from "./LyricPreview.vue?vue&type=style&index=0&id=4ba9c2dc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ba9c2dc",
  null
  
)

export default component.exports